import React from "react";
import { PAYMENT_AUTOPAY_INFO } from "utils/constants";

const PaymentAutopayInfoModal = () => (
  <div className="relative bg-white outline-none w-auto h-auto p-10">
    <h1 className="text-green-primary text-lg">How much am I paying?</h1>
    <p>{PAYMENT_AUTOPAY_INFO}</p>
  </div>
);

export default PaymentAutopayInfoModal;
